





















import { Vue, Prop, Component } from "vue-property-decorator";
import { StringVariable as IStringVariable } from "@/api-v2/document-generator/models/string-variable";
import { ListVariable as IListVariable } from "@/api-v2/document-generator/models/list-variable";

@Component
export default class DocTemplateVariablesItem extends Vue {
  @Prop() variable!: IStringVariable | IListVariable;

  formattedName(name: string) {
    return `$\{${name}}`;
  }

  copyToBuffer(item: string) {
    const text = `$\{${item}}`;
    navigator.clipboard.writeText(text);
  }
}
